module.exports = __webpack_public_path__ + "img/bt6.0c5625a3.png";